export default __webpack_public_path__ + "static/media/image14.cb8c0a71.jpg";